import { Component, Input } from '@angular/core';
import { ChartSize } from '@models';

@Component({
  selector: 'drilldown-chart-no-data-available',
  templateUrl: './drilldown-chart-no-data-available.component.html',
  styleUrl: './drilldown-chart-no-data-available.component.scss'
})
export class DrilldownChartNoDataAvailableComponent {
  @Input() size!: ChartSize;
}
